module.exports = __webpack_public_path__ + "img/b2.d7d29d32.png";